/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useState } from 'react'
import { SectionHelper } from 'Lib/Text'
import { List, ListItem } from 'Lib/List'
import Overlay from 'Lib/Overlay'
import Modal from 'Lib/Modal'
import Cross from 'AccountsIcons/cross.svg'
import TimeLinePriceContainer from './TimeLineBlock/TimeLinePriceContainer'

import TimeDurationContainer from './TimeLineBlock/TimeDurationContainer'
import TimeDuration from './TimeLineBlock/TimeDuration'
import TimeLinePrice from './TimeLineBlock/TimeLinePrice'
import FareRuleRefundBreakUp from './FareRuleRefundBreakUp'

const FareRulesWidgetPwa = ({ data = null, isRefundFareRule = false, marginTop, onClose = () => { } }) => {
  let cancelationPolicyBlock = ''
  let dateChangePolicyBlock = ''
  const { fareDetails, indexOfFaq = 0 } = data || {}
  const {
    departureCity,
    arrivalCity,
    departureTime,
    fareRules,
    currency,
    isSplRt = false,
    policyText = '',
    disclaimerText = ''
  } = fareDetails || {}
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [breakupItem, setBreakupItem] = useState('')
  const disclaimerTextArray = disclaimerText && disclaimerText.split('/')
  const handleDetailModalClick = item => {
    setBreakupItem(item)
    setShowDetailModal(!showDetailModal)
  }

  const dateDiffTimeDate = (date1, date2) => {
    const start = new Date(date1)
    const end = new Date(date2)
    const diffInDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
    const diffInHrs = end.getHours() - start.getHours()
    if (diffInDays !== 0) {
      return diffInDays > 1 ? `${diffInDays} days` : `${diffInDays} day`
    }
    return diffInHrs > 1 ? `${diffInHrs} hours` : `${diffInHrs} hour`
  }

  if (fareRules) {
    const { cancelCharges = [], amendCharges = [] } = fareRules || {}
    if (cancelCharges && cancelCharges.length > 0) {
      let startTime = ''
      const firstFareRule = cancelCharges[0]
      const { timeline: startTimeLine } = firstFareRule
      startTime = startTimeLine.startTimeDate
      cancelationPolicyBlock = (

        <ListItem className="flex pt-0010 pb-0025 pl-001 pr-0">
          <TimeDurationContainer>
            <div className="flex flex-right flex-middle">
              <div className="pl-0010 pr-0010 flex flex-column ta-r">
                <span className="fs-13 c-black-60">
                  {startTime}
                </span>
              </div>
              <div className="pl-2 arrow-triangle__grey" />
            </div>
            {cancelCharges && cancelCharges.map((item, index) => {
              const { timeline = {} } = item
              return <TimeDuration time={timeline.endTimeDate} duration={dateDiffTimeDate(timeline.endTimeDate, departureTime)} />
            })}

          </TimeDurationContainer>
          <TimeLinePriceContainer>
            {cancelCharges && cancelCharges.map((item, index) => {
              const { refundableAmount } = item
              return (
                <TimeLinePrice
                  price={refundableAmount}
                  item={item}
                  itemIndex={index}
                  index={cancelCharges.length - index}
                  currency={currency}
                  handleDetailModalClick={handleDetailModalClick}
                />
              )
            })}
          </TimeLinePriceContainer>

        </ListItem>
      )
    }
    if (amendCharges && amendCharges.length > 0) {
      let startTime = ''
      const firstFareRule = amendCharges[0]
      const { timeline: startTimeLine } = firstFareRule
      startTime = startTimeLine.startTimeDate
      dateChangePolicyBlock = (
        <ListItem className="flex pt-0010 pb-0025 pl-001 pr-0">
          <TimeDurationContainer>
            <div className="flex flex-right flex-middle">
              <div className="pl-0010 pr-0010 flex flex-column ta-r">
                <span className="fs-13 c-black-60">
                  {startTime}
                </span>
              </div>
              <div className="pl-2 arrow-triangle__grey" />
            </div>
            {amendCharges && amendCharges.map((item, index) => {
              const { timeline = {} } = item
              return <TimeDuration time={timeline.endTimeDate} duration={dateDiffTimeDate(timeline.endTimeDate, departureTime)} />
            })}

          </TimeDurationContainer>
          <TimeLinePriceContainer>
            {amendCharges && amendCharges.map((item, index) => {
              const { amendSameFareCharges = [] } = item
              let amendAdtSameFare
              if (amendSameFareCharges) {
                amendAdtSameFare = amendSameFareCharges.filter(
                  fareCharges => {
                    return fareCharges && fareCharges.paxType === 'ADT'
                  }
                )
              }

              const { dateChangeCharge, nonAmend = false } = amendAdtSameFare[0] || {}
              return (
                <TimeLinePrice
                  price={dateChangeCharge}
                  item={item}
                  itemIndex={index}
                  index={amendCharges.length - index}
                  currency={currency}
                  nonAmend={nonAmend}
                  charge="dateChange"
                />
              )
            })}
          </TimeLinePriceContainer>

        </ListItem>
      )
    }
  }
  const cancellationRenderedBlock = () => {
    return (
      <>
        <div>
          {isRefundFareRule && (
            <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016">
              <p className="fs-14 fw-500">Cancellation Charges</p>
            </div>
          )}
          <List>
            <ListItem className="h-40 flex flex-middle flex-between">
              <p className="fs-13 c-black-60 fw-500">Cancel between</p>
              <p>
                <span className="fs-13 c-black-60 fw-500">Amount refundable</span>
              </p>
            </ListItem>
            {cancelationPolicyBlock}
          </List>
        </div>
      </>
    )
  }

  return (
    <div>
      {isRefundFareRule && (
        <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016" style={{ backgroundColor: '#f6f6f8', position: 'fixed', top: '-1px', width: '100%', zIndex: '10' }}>
          <p className="fs-14 fw-500">Fare Rule</p>
          <span onClick={() => onClose()}>
            <Cross fill="#4d4d4d" />
          </span>
        </div>
      )
      }
      {!isSplRt && (
        <div className="flex flex-between  ">
          <div
            className={`flex flex-middle px-4 pb-0010 flex-1 ${marginTop ||
              ''}`}
          >
            {/* <p className="fs-4 c-neutral-900 fw-700 lh-title">{fareDisplayName}</p> */}
            <div className="fs-body  fw-700 lh-title">{departureCity}</div>
            <div className="fs-body  fw-700 lh-title mx-1">→</div>
            <div className="fs-body  fw-700 lh-title mx-1">{arrivalCity}</div>
            <div className="fs-body  fw-700 lh-title mx-1">:</div>
            <div className="fs-body  fw-700 lh-title">{departureTime}</div>
          </div>
        </div>
      )}
      {
        isSplRt && disclaimerText && (indexOfFaq === 0) && (
          <div className="flex p-4 flex-top bg-warning-100 mb-4 mx-4 br-10">
            <div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g mask="url(#mask0_3103_74599)">
                  <path d="M12 16.5C12.15 16.5 12.271 16.4543 12.363 16.363C12.4543 16.271 12.5 16.15 12.5 16V11.475C12.5 11.3417 12.45 11.229 12.35 11.137C12.25 11.0457 12.1333 11 12 11C11.85 11 11.729 11.05 11.637 11.15C11.5457 11.25 11.5 11.3667 11.5 11.5V16.025C11.5 16.1583 11.55 16.271 11.65 16.363C11.75 16.4543 11.8667 16.5 12 16.5ZM12 9.575C12.1667 9.575 12.3127 9.51667 12.438 9.4C12.5627 9.28333 12.625 9.13333 12.625 8.95C12.625 8.78333 12.5627 8.64167 12.438 8.525C12.3127 8.40833 12.1667 8.35 12 8.35C11.8333 8.35 11.6873 8.40833 11.562 8.525C11.4373 8.64167 11.375 8.78333 11.375 8.95C11.375 9.13333 11.4373 9.28333 11.562 9.4C11.6873 9.51667 11.8333 9.575 12 9.575ZM12 21C10.75 21 9.575 20.7667 8.475 20.3C7.375 19.8333 6.421 19.196 5.613 18.388C4.80433 17.5793 4.16667 16.625 3.7 15.525C3.23333 14.425 3 13.25 3 12C3 10.75 3.23333 9.575 3.7 8.475C4.16667 7.375 4.80433 6.42067 5.613 5.612C6.421 4.804 7.375 4.16667 8.475 3.7C9.575 3.23333 10.75 3 12 3C13.25 3 14.425 3.23333 15.525 3.7C16.625 4.16667 17.5793 4.804 18.388 5.612C19.196 6.42067 19.8333 7.375 20.3 8.475C20.7667 9.575 21 10.75 21 12C21 13.25 20.7667 14.425 20.3 15.525C19.8333 16.625 19.196 17.5793 18.388 18.388C17.5793 19.196 16.625 19.8333 15.525 20.3C14.425 20.7667 13.25 21 12 21ZM12 20C14.2167 20 16.1043 19.221 17.663 17.663C19.221 16.1043 20 14.2167 20 12C20 9.78333 19.221 7.89567 17.663 6.337C16.1043 4.779 14.2167 4 12 4C9.78333 4 7.896 4.779 6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 14.2167 4.77933 16.1043 6.338 17.663C7.896 19.221 9.78333 20 12 20Z" fill="#DF9641" />
                </g>
              </svg>
            </div>
            <p className="pl-2 fs-2">{disclaimerTextArray[0]}<b>{disclaimerTextArray[1]}</b>{disclaimerTextArray[2]}</p>
          </div>
        )
      }
      {
        !isSplRt ?
          cancelationPolicyBlock && cancellationRenderedBlock() :
          cancelationPolicyBlock && (indexOfFaq === 0) && cancellationRenderedBlock()
      }
      {
        dateChangePolicyBlock && (
          <>
            <div>
              {isRefundFareRule && (
                <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016">
                  <p className="fs-14 fw-500">Date Change Charges</p>

                </div>
              )}
              <List>
                <ListItem className="h-40 flex flex-middle flex-between">
                  <p>
                    <span className="fs-13 c-black-60 fw-500">
                      Change between
                    </span>
                  </p>
                  <p>
                    <span className="fs-13 c-black-60 fw-500">
                      Date change charges(Per Adult)
                    </span>
                  </p>
                </ListItem>
                {dateChangePolicyBlock}
              </List>

            </div>
          </>
        )

      }
      <If condition={isSplRt && !dateChangePolicyBlock}>
        {policyText && (indexOfFaq === 0) && (
          <div className="pt-0010">
            <SectionHelper className="mt-005">
              <p className="lh-copy pb-0040">
                <span className="">*before the time of departure of your flight</span>
              </p>
              <p className="lh-copy pb-0040">
                <span className="fw-500">Note</span>:  {policyText}
              </p>
            </SectionHelper>
          </div>
        )}
        <Else />
        <div className="pt-0010">
          <SectionHelper className="mt-005">
            <p className="lh-copy pb-0040">
              <span className="">*before the time of departure of your flight</span>
            </p>
            <p className="lh-copy pb-0040">
              <span className="fw-500">Note</span>:  {policyText}
            </p>
          </SectionHelper>
        </div>
      </If>

      <If condition={showDetailModal}>
        <div className="flex flex-middle ml-1 mt-1">
          <Overlay>
            <Modal type="renderProp" bottom={true} className="modal-pwa">
              <FareRuleRefundBreakUp
                onClose={handleDetailModalClick}
                breakupItem={breakupItem}
                currency={currency}
              />
            </Modal>
          </Overlay>
        </div>
      </If>
    </div>
  )
}

export default FareRulesWidgetPwa
